import { render, staticRenderFns } from "./MergerAcquisitionsListView.vue?vue&type=template&id=4a9e83eb&scoped=true&"
import script from "./MergerAcquisitionsListView.vue?vue&type=script&lang=ts&"
export * from "./MergerAcquisitionsListView.vue?vue&type=script&lang=ts&"
import style0 from "./MergerAcquisitionsListView.vue?vue&type=style&index=0&id=4a9e83eb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9e83eb",
  null
  
)

export default component.exports